import { useEffect } from 'react';
import { useProductStore } from './src-store-productPriceDetails.store.js';

const useSetPriceConfigs = (baseConfig) => {
  const setBasePriceExtractionConfig = useProductStore(
    (state) => state.setBasePriceExtractionConfig
  );
  useEffect(() => {
    setBasePriceExtractionConfig(baseConfig);
  }, [baseConfig, setBasePriceExtractionConfig]);
};

export { useSetPriceConfigs };
//# sourceMappingURL=src-components-PriceExtraction-useSetPriceConfigs.hook.js.map
